<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg2340"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs2344"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2354"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2352" /></clipPath></defs><g
     id="g2346"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g2348"><g
         id="g2350"
         clip-path="url(#clipPath2354)"><g
           id="g2356"
           transform="translate(222.9668,285.2988)"><path
             d="M 0,0 H 55.418 L -17.649,73.068 V 17.649 C -17.649,7.902 -9.748,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2358" /></g><g
           id="g2360"
           transform="translate(10.1167,340.7178)"><path
             d="m 0,0 v -315.568 c 0,-9.748 7.902,-17.65 17.649,-17.65 h 232.97 c 9.748,0 17.65,7.902 17.65,17.65 V -55.419 L 195.201,17.649 H 17.649 C 7.902,17.649 0,9.747 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:519, 35, 384, 0;stroke-dashoffset:0;stroke-opacity:1"
             id="path2362" /></g><g
           id="g2364"
           transform="translate(52.4751,242.0361)"><path
             d="M 0,0 H 183.552"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2366" /></g><g
           id="g2368"
           transform="translate(52.4751,194.9717)"><path
             d="M 0,0 H 183.552"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2370" /></g><g
           id="g2372"
           transform="translate(52.4751,147.9072)"><path
             d="M 0,0 H 183.552"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2374" /></g><g
           id="g2376"
           transform="translate(52.4751,100.8428)"><path
             d="M 0,0 H 183.552"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2378" /></g><g
           id="g2380"
           transform="translate(446.4644,431.4326)"><path
             d="M 0,0 H 55.419 L -17.649,73.067 V 17.648 C -17.649,7.901 -9.747,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2382" /></g><g
           id="g2384"
           transform="translate(275.9727,388.1699)"><path
             d="M 0,0 H 183.552"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2386" /></g><g
           id="g2388"
           transform="translate(275.9727,341.1045)"><path
             d="M 0,0 H 183.552"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2390" /></g><g
           id="g2392"
           transform="translate(275.9727,294.04)"><path
             d="M 0,0 H 183.552"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2394" /></g><g
           id="g2396"
           transform="translate(278.3853,246.9756)"><path
             d="M 0,0 H 181.14"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2398" /></g><g
           id="g2400"
           transform="translate(94.7173,399.2549)"><path
             d="M 0,0 V 0 C 0,23.894 19.369,43.263 43.263,43.263 H 69.025"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2402" /></g><g
           id="g2404"
           transform="translate(163.7427,460.123)"><path
             d="m 0,0 v -35.21 c 0,-3.773 3.984,-6.216 7.346,-4.505 l 34.6,17.606 c 3.682,1.873 3.682,7.134 0,9.008 L 7.346,4.505 C 3.984,6.216 0,3.772 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2406" /></g><g
           id="g2408"
           transform="translate(423.3521,121.3408)"><path
             d="M 0,0 V 0 C 0,-23.894 -19.369,-43.263 -43.263,-43.263 H -69.025"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2410" /></g><g
           id="g2412"
           transform="translate(354.3267,60.4736)"><path
             d="m 0,0 v 35.21 c 0,3.772 -3.984,6.215 -7.346,4.504 L -41.945,22.109 c -3.683,-1.874 -3.683,-7.135 0,-9.009 L -7.346,-4.505 C -3.984,-6.216 0,-3.773 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2414" /></g><g
           id="g2416"
           transform="translate(428.8154,504.5)"><path
             d="m 0,0 h -177.552 c -9.747,0 -17.649,-7.902 -17.649,-17.649 v -156.782 l 44.771,-44.77 V -350.867 H 55.418 c 9.748,0 17.65,7.902 17.65,17.649 v 260.15 z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:719, 35, 600, 0;stroke-dashoffset:0;stroke-opacity:1"
             id="path2418" /></g></g></g></g></svg>
</template>
